var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	7892: {
		fallback: () => (() => (__webpack_require__(5739))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.7",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	3290: {
		fallback: () => (() => (__webpack_require__(4258))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.7",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	8158: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_19_2_7_node_modules_react_jsx-dev-runtime_js").then(() => (() => (__webpack_require__(7105))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-dev-runtime",

	},
	6452: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_19_2_7_react_19_2_7_node_modules_react-dom_client_js").then(() => (() => (__webpack_require__(6315))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	3701: {
		fallback: () => (() => (__webpack_require__(3633))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.30.6",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	8789: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_lucide-react_1_17_0_react_19_2_7_node_modules_lucide-react_dist_esm-2c27ea").then(() => (() => (__webpack_require__(7501))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.17.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lucide-react",

	},
	6643: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_sonner_2_0_7_react-dom_19_2_7_react_19_2_7__react_19_2_7_node_modul-8a88bd").then(() => (() => (__webpack_require__(4137))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.0.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "sonner",

	},
	848: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_axios_1_20_0_node_modules_axios_index_js").then(() => (() => (__webpack_require__(5977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	7832: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustand_esm_in-b48b16").then(() => (() => (__webpack_require__(2154))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.5.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "zustand",

	},
	7265: {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustan-8edc0c").then(() => (() => (__webpack_require__(2422))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.5.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "zustand/middleware",

	},
	9131: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustand_esm_va-66cfe7").then(() => (() => (__webpack_require__(4219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.5.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "zustand/vanilla",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [7892,3290,7892,3290];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"main": [
		7892,
		3290
	],
	"styles": [
		7892,
		3290
	],
	"src_bootstrap_tsx": [
		8158,
		6452,
		3701,
		8789,
		6643,
		848,
		7832,
		7265
	],
	"node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustand_esm_in-b48b16": [
		9131
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}